<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card class="p-0 m-0">
        <div slot="header" class="d-flex">
          <strong>Rate Markup</strong>
          <button class="btn btn-info ml-auto" @click="$router.push('RateMarkupEx')"><i title="Ex" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Edit Extended Rate Markup Settings</strong></button>
          <button class="btn btn-info ml-auto" @click="saveOptions"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
        </div>
        <b-row>
          <b-col md="6" class="p-0 m-0">
            <b-card>
              <div slot="header">
                <strong>Lease</strong>
              </div>
              <b-row>
                <b-col md="12" class="p-0 m-0">
                  <b-list-group>
                    <b-list-group-item variant="info"><strong>New</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Accept Lower Max. Rate
                        </b-col>
                        <b-col md="3">
                          <c-switch id="swLeaseNewAccept" size="sm" v-model="rateMarkup.LeaseRateMarkUp.AcceptLowerMaxRate" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Money Factor
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeaseNewMF" size="sm" type="text" v-model.number="rateMarkup.LeaseRateMarkUp.Factor"
                                            list="rate-markup-list"
                                            v-on:change='RecalcMarkUp_LeaseRate(rateMarkup.Lease.New)'>
                              </b-form-input>
                              <datalist id="rate-markup-list">
                                <option v-for="element in RateMarkUpList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnLeaseNewMF" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.LeaseRateMarkUp)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>

                          </b-row>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          APR
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeaseNewAPR" size="sm" type="text" v-model.number="rateMarkup.LeaseRateMarkUp.APR" list="apr-list" v-on:change='RecalcMarkUp_FactorMarkUp(rateMarkup.LeaseRateMarkUp)'></b-form-input>
                              <datalist id="apr-list">
                                <option v-for="element in APRList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnLeaseNewAPR" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.LeaseRateMarkUp)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-list-group-item>

                    <b-list-group-item variant="info"><strong>Used</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Accept Lower Max. Rate
                        </b-col>
                        <b-col md="3">
                          <c-switch id="swLeaseUsedAccept" size="sm" v-model="rateMarkup.LeaseRateMarkUpUsed.AcceptLowerMaxRate" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Money Factor
                        </b-col>
                        <b-col md="5">

                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeaseUsedMF" size="sm" type="text" v-model.number="rateMarkup.LeaseRateMarkUpUsed.Factor" list="rate-markup-list-2" v-on:change='RecalcMarkUp_LeaseRate(rateMarkup.LeaseRateMarkUpUsed)'></b-form-input>
                              <datalist id="rate-markup-list-2">
                                <option v-for="element in RateMarkUpList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnLeaseUsedMF" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.LeaseRateMarkUpUsed)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>

                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          APR
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeaseUsedAPR" size="sm" type="text" v-model.number="rateMarkup.LeaseRateMarkUpUsed.APR" list="apr-list-2" v-on:change='RecalcMarkUp_FactorMarkUp(rateMarkup.LeaseRateMarkUpUsed)'></b-form-input>
                              <datalist id="apr-list-2">
                                <option v-for="element in APRList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnLeaseUsedAPR" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.LeaseRateMarkUpUsed)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>

                    <b-list-group-item variant="info"><strong>Demo</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Accept Lower Max. Rate
                        </b-col>
                        <b-col md="3">
                          <c-switch id="swLeaseDemoAccept" size="sm" v-model="rateMarkup.LeaseRateMarkUpDemo.AcceptLowerMaxRate" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Money Factor
                        </b-col>
                        <b-col md="5">

                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeaseDemoMF" size="sm" type="text" v-model.number="rateMarkup.LeaseRateMarkUpDemo.Factor" list="rate-list-3" v-on:change='RecalcMarkUp_LeaseRate(rateMarkup.LeaseRateMarkUpDemo)'></b-form-input>
                              <datalist id="rate-list-3">
                                <option v-for="element in RateMarkUpList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnLeaseDemoMF" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.LeaseRateMarkUpDemo)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>

                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          APR
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeaseDemoAPR" size="sm" type="text" v-model.number="rateMarkup.LeaseRateMarkUpDemo.APR" list="apr-list-3" v-on:change='RecalcMarkUp_FactorMarkUp(rateMarkup.LeaseRateMarkUpDemo)'></b-form-input>
                              <datalist id="apr-list-3">
                                <option v-for="element in APRList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnLeaseDemoAPR" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.LeaseRateMarkUpDemo)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>

                    <b-list-group-item variant="info"><strong>Paid Reserve</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Value
                        </b-col>
                        <b-col md="5">

                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeasePaidResValue" size="sm" type="text" v-model="rateMarkup.LeaseDesiredPaidReserve" name="LeasePaidReserveValue" v-validate="{decimal:true}"
                                            v-bind:class="{'is-invalid': validateErrors.has('LeasePaidReserveValue') }"></b-form-input>
                            </span>
                            <span>
                              <b-button id="btnLeasePaidResValue" size="sm" class="btn btn-info" v-on:click="rateMarkup.LeaseDesiredPaidReserve=0" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                            <em class="error invalid-feedback">{{ validateErrors.first('LeasePaidReserveValue') }}</em>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Range
                        </b-col>
                        <b-col md="5">

                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtLeasePaidResRange" size="sm" type="text" v-model="rateMarkup.LeaseDesiredPaidReserveRange" name="LeasePaidReserveRange" v-validate="{decimal:true}"
                                            v-bind:class="{'is-invalid': validateErrors.has('LeasePaidReserveRange') }"></b-form-input>
                            </span>
                            <span>
                              <b-button id="btnLeasePaidResRange" size="sm" class="btn btn-info" v-on:click="rateMarkup.LeaseDesiredPaidReserveRange=0" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                            <em class="error invalid-feedback">{{ validateErrors.first('LeasePaidReserveRange') }}</em>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col md="6" class="p-0 m-0">
            <b-card>
              <div slot="header">
                <strong>Retail</strong>
              </div>
              <b-row>
                <b-col md="12">
                  <b-list-group>
                    <b-list-group-item variant="info"><strong>New</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Accept Lower Max. Rate
                        </b-col>
                        <b-col md="3">
                          <c-switch id="swRetailNewAccept" size="sm" v-model="rateMarkup.RetailRateMarkUp.AcceptLowerMaxRate" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          APR
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtRetailNewAPR" size="sm" type="text" v-model.number="rateMarkup.RetailRateMarkUp.APR" list="apr-list-4"></b-form-input>
                              <datalist id="apr-list-4">
                                <option v-for="element in APRList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnRetailNewAPR" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.RetailRateMarkUp)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item variant="info"><strong>Used</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Accept Lower Max. Rate
                        </b-col>
                        <b-col md="3">
                          <c-switch id="swRetailUsedAccept" size="sm" v-model="rateMarkup.RetailRateMarkUpUsed.AcceptLowerMaxRate" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          APR
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtRetailUsedAPR" size="sm" type="text" v-model.number="rateMarkup.RetailRateMarkUpUsed.APR" list="apr-list-5"></b-form-input>
                              <datalist id="apr-list-5">
                                <option v-for="element in APRList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnRetailUsedAPR" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.RetailRateMarkUpUsed)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item variant="info"><strong>Demo</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Accept Lower Max. Rate
                        </b-col>
                        <b-col md="3">
                          <c-switch id="swRetailDemoAccept" size="sm" v-model="rateMarkup.RetailRateMarkUpDemo.AcceptLowerMaxRate" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          APR
                        </b-col>
                        <b-col md="5">
                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtRetailDemoAPR" size="sm" type="text" v-model.number="rateMarkup.RetailRateMarkUpDemo.APR" list="apr-list-6"></b-form-input>
                              <datalist id="apr-list-6">
                                <option v-for="element in APRList">{{ element }}</option>
                              </datalist>
                            </span>
                            <span>
                              <b-button id="btnRetailDemoAPR" size="sm" class="btn btn-info" v-on:click="clear(rateMarkup.RetailRateMarkUpDemo.APR)" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>

                    <b-list-group-item variant="info"><strong>Paid Reserve</strong></b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Value
                        </b-col>
                        <b-col md="5">

                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtRetailPaidResValue" size="sm" type="text" v-model="rateMarkup.RetailDesiredPaidReserve" name="RetailPaidReserveValue" v-validate="{decimal:true}"
                                            v-bind:class="{'is-invalid': validateErrors.has('RetailPaidReserveValue') }"></b-form-input>
                            </span>
                            <span>
                              <b-button id="btnRetailPaidResValue" size="sm" class="btn btn-info" v-on:click="rateMarkup.RetailDesiredPaidReserve=0" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                            <em class="error invalid-feedback">{{ validateErrors.first('RetailPaidReserveValue') }}</em>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="3">
                          Range
                        </b-col>
                        <b-col md="5">

                          <b-row style="min-width:200px">
                            <span>
                              <b-form-input id="txtRetailPaidResRange" size="sm" type="text" v-model="rateMarkup.RetailDesiredPaidReserveRange" name="RetailPaidReserveRange" v-validate="{decimal:true}"
                                            v-bind:class="{'is-invalid': validateErrors.has('RetailPaidReserveRange') }"></b-form-input>
                            </span>
                            <span>
                              <b-button id="btnRetailPaidResRange" size="sm" class="btn btn-info" v-on:click="rateMarkup.RetailDesiredPaidReserveRange=0" v-b-tooltip.hover title="Clear">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </span>
                            <em class="error invalid-feedback">{{ validateErrors.first('RetailPaidReserveRange') }}</em>
                          </b-row>

                        </b-col>
                      </b-row>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import cSwitch from '../components/Switch'

  export default {
    components: {
      loading,
      cSwitch
    },
    created() {
      axios.get('/api/ratemarkup/loaddata')
        .then(response => {
          console.log('Debug', response.data)
          this.boolLoading = false

          this.rateMarkup = response.data

        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        RateMarkUpList: ['0.00025', '0.00050', '0.00075', '0.001', '0.00125', '0.00150', '0.00175', '0.00200'],
        APRList: ['0.25', '0.50', '0.75', '1.00', '1.25', '1.50', '1.75', '2.00', '2.25', '2.50'],

        rateMarkup: {
          Lease: {
            New: { APR: 0, Factor: 0, AcceptLowerMaxRate: false },
            Used: { APR: 0, Factor: 0, AcceptLowerMaxRate: false },
            Demo: { APR: 0, Factor: 0, AcceptLowerMaxRate: false },
            PaidReserve: { Range: 0, Value: 0 }
          },
          Retail: {
            New: { APR: 0, AcceptLowerMaxRate: false },
            Used: { APR: 0, AcceptLowerMaxRate: false },
            Demo: { APR: 0, AcceptLowerMaxRate: false },
            PaidReserve: { Range: 0, Value: 0 }
          }
        }
      }
    },
    methods: {
      clear: function (lease_type) {
        if (lease_type.Factor != null) {
          lease_type.Factor = 0
        }
        if (lease_type.APR != null) {
          lease_type.APR = 0
        }
      },
      RecalcMarkUp_LeaseRate: function (lease_type) {
        if (lease_type.Factor > 0) {
          try {
            var v = Math.round(lease_type.Factor * 240000) / 100
            if (v > 30) { v = 30 }
            lease_type.APR = v
          } catch (ex) { }
        } else {
          lease_type.Factor = 0
        }
      },
      RecalcMarkUp_FactorMarkUp: function (lease_type) {
        if (lease_type.APR > 0) {
          try {
            var v = Math.round(lease_type.APR * 1000000 / 2400) / 1000000
            if (v > 0.0099) { v = 0.0099 }
            lease_type.Factor = v
          } catch (ex) { }
        } else {
          lease_type.APR = 0
        }
      },
      isNumeric: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n)
      },

      saveOptions() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (!this.rateMarkup) {
              this.errMsg = 'Unknown error.'
              this.showDismissibleAlert = true
              return
            }

            this.boolLoading = true
            var obj = {}
            obj.data = this.rateMarkup


            axios.post('/api/ratemarkup/save', obj)
              .then(response => {
                this.errMsg = 'Rate Markup Saved'
                this.dismissibleType = 'success'
                this.showDismissibleAlert = true
                this.boolLoading = false
              })
              .catch(error => {
                if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

                console.log(error)
                this.boolLoading = false
                this.errMsg = 'There was an error saving data : ' + error
                this.showDismissibleAlert = true

                if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
              })
          }
        })
      },
      nullOnEmpty(o) {
        if (o.value == '') { o.value = null }
      }
    },
    mounted() {
      // boolLoading must be set to false on data() binding so that mount hooks the change
      this.boolLoading = true
    }
  }
</script>
<style>
  .invalid-feedback {
    display: block !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/RateMarkup.vue